import axios from "axios";

const axiosWithLocation = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// For GET requests
axiosWithLocation.interceptors.request.use(
  (req) => {
    const token = localStorage.getItem("token");
    const location = JSON.parse(localStorage.getItem("location"));
    // Add configurations here
    if (token && location) {
      req.headers = {
        Authorization: `Bearer ${token}`,
        Location: location.id,
      };
    }
    return req;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// For POST requests
axiosWithLocation.interceptors.response.use(
  (res) => {
    // Add configurations here
    if (res.status === 201) {
      console.log("Posted Successfully");
    }
    return res;
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default axiosWithLocation;
